import * as Yup from "yup";
import { IUseBoolean, useBoolean } from "../../../hooks/use-boolean";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IBranch, IBranchUpdate } from "../../../types/branch";
import { UpdateBranchService } from "../../../services/branches";
import { enqueueSnackbar } from "notistack";

const useBranchUpdate = (loadingTable: IUseBoolean, getBranches: VoidFunction) => {

    const openUpdateBranch = useBoolean();
    const loadingUpdate = useBoolean(false);

    // rhf
    const UpdateBranchSchema = Yup.object().shape({
        id: Yup.number().required('Informe o id'),
        name: Yup.string().required('Informe o nome da filial').max(255, 'O nome deve conter no máximo 255 caracteres'),
        code: Yup.string().required('Informe o código da filial').max(10, 'O código deve conter no máximo 10 caracteres'),
    });

    const updateMethods = useForm({
        resolver: yupResolver<IBranchUpdate>(UpdateBranchSchema),
        defaultValues: {
            id: null,
            code: '',
            name: '',
        }
    });

    const {
        handleSubmit,
        reset,
        setValue
    } = updateMethods;

    const selectBranchToUpdate = (branch: IBranch) => {
        setValue("id", branch.id, { shouldValidate: true });
        setValue("code", branch.code, { shouldValidate: true });
        setValue("name", branch.name, { shouldValidate: true });
        openUpdateBranch.onTrue();
    }

    const closeDialogUpdate = () => {

        reset({
            id: null,
            code: '',
            name: ''
        });

        openUpdateBranch.onFalse();

    }

    const onSubmitUpdate = handleSubmit(async (data: IBranchUpdate) => {

        loadingUpdate.onTrue();
        loadingTable.onTrue();

        await UpdateBranchService(data).then(resp => {
            closeDialogUpdate();
            enqueueSnackbar(resp.data.message);
            loadingUpdate.onFalse();
            getBranches();
        }).catch(error => {

            loadingUpdate.onFalse();
            loadingTable.onFalse();

            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        })

    });

    return {
        openUpdateBranch,
        loadingUpdate,
        updateMethods,
        onSubmitUpdate,
        selectBranchToUpdate,
        closeDialogUpdate
    }

}

export default useBranchUpdate;